export default function Hero() {
  return (
    <section id="home" className="relative flex items-center justify-center overflow-hidden" style={{ minHeight: 'calc(100vh - 80px)' }}>
      {/* Updated World Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/edited_ce8287a420644f4f746ac4415ab6424b_14c1dfc6.jpg')`
        }}
      />
      
      {/* Semi-transparent overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1B4B6B]/30 via-[#1B4B6B]/20 to-[#1B4B6B]/35"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full flex flex-col items-center justify-center">
        {/* Logo - Centered Focal Point */}
        <div className="mb-10">
          <img 
            src="https://storage.readdy-site.link/project_files/11bf54dc-cd8b-412f-9383-b1020052ccc0/e790e585-9341-4eda-8466-7e9d89aa3fd5_ChatGPT-Image-Mar-2-2026-12_02_26-PM-ek.png?v=e86025dbcd928cb45795c7555e605914" 
            alt="BB Beyhan Balance Global Financial Administration Logo" 
            className="h-56 w-56 object-contain mx-auto drop-shadow-2xl"
          />
        </div>

        {/* BB Beyhan Balance - Updated colors to match logo */}
        <div className="mb-6">
          <h1 className="text-7xl font-bold mb-2">
            <span className="text-[#C8963E]" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>BB</span>
            <span className="text-3xl font-medium text-white ml-4 align-middle" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>Beyhan Balance</span>
          </h1>
          <p className="text-2xl text-white font-light tracking-wide" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
            Global Financial Administration
          </p>
        </div>

        {/* Slogans */}
        <div className="mb-8 space-y-3">
          <p className="text-xl text-white font-light italic" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.6)' }}>
            "Always by your side, ready to support, guide, and ease the load"
          </p>
        </div>

        {/* CTA Button */}
        <a 
          href="#contact" 
          className="inline-block px-10 py-4 bg-gradient-to-r from-[#C8963E] to-[#D4A54E] text-white text-lg font-semibold rounded-full hover:shadow-2xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          style={{ textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}
        >
          Get in Touch
        </a>
      </div>
    </section>
  );
}